// ================= Home Part ==================== //
export const SAVE_LOADINGS = 'SAVE_LOADINGS';
export const LOAD_NEWS = 'LOAD_NEWS';
export const LOAD_SERVICES = 'LOAD_SERVICES';
export const LOAD_NEW_CATEGORY = 'LOAD_NEW_CATEGORY';